<div class="login-info" >
  <!-- <span>
    <a data-toggle="dropdown" class="dropdown-toggle">
     <img [src]="" alt="me"  class="online"/>
     <span >{{user.fullName }}</span>&nbsp;<i class="fa fa-angle-down"></i>
    </a>
    <ul class="dropdown-menu">
        <li><a href="#">HTML</a></li>
        <li><a href="#">CSS</a></li>
        <li><a href="#">JavaScript</a></li>
      </ul> -->
      <!-- <div class="dropdown">
          <a class="dropdown-toggle" data-toggle="dropdown">Dropdown Example
          <span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li><a href="#">HTML</a></li>
            <li><a href="#">CSS</a></li>
            <li><a href="#">JavaScript</a></li>
          </ul>
      </div> 
   </span>-->


   <span dropdown (onShown)="onShown()" (onHidden)="onHidden()" (isOpenChange)="isOpenChange()">
      <a class="dropdown-toggle" id="basic-link" dropdownToggle (click)="false" aria-controls="basic-link-dropdown">
          <img [src]="'/assets/img/avatars/male.png'" alt="me"  class="online"/>
          <span>{{user.fullName }}</span>  &nbsp;<i class="fa fa-angle-down"></i>
      </a>
      <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu"
          role="menu" aria-labelledby="basic-link">
          <li><a class="dropdown-item" (click)="editProfile()"> Edit Profile</a></li>
          <li><a class="dropdown-item" (click)="showPopup()" >Logout</a></li>

        <!-- <li *ngFor="let choice of items">
          <a class="dropdown-item" href="#">{{choice}}</a>
        </li> -->
      </ul>
    </span>

 
</div>
